export default "__VITE_ASSET__CS1JM5P4__"